<template>
  <b-container
    :fluid="true"
    tag="section"
    class="dashboard">
    <b-row
      class="title ml-0 mr-0 mb-4"
      :class="{'announcement-space': showAnnouncement }">
      <b-col
        md="12"
        class=" left-40">
        <h2 class="sb2_reports_title">
          Activity
        </h2>
      </b-col>
    </b-row>
    <b-row v-if="noPermission || forbidden">
      <b-col
        md="12"
        class="left-40" >
        <Forbidden />
      </b-col>
    </b-row>
    <b-row
      v-if="!noPermission && !forbidden"
      class="ml-0 mr-0 sticky-top">
      <b-col
        md="12"
        class="left-40 right-40 action-bar">
        <!-- Actions bar -->
        <!-- Search section -->
        <div class="flex space-between settings--box">
          <div class="flex">
            <!-- Time FILTER -->
            <DatePicker
              ref="dateRange"
              :start-date="null"
              :omit-shortcuts="[]"
              :week-mode="isWeekMode"
              :month-mode="isMonthMode"
              @datesChanged="dateRangeChange"/>
            <!-- 'yesterday', 'last365Days' -->

            <!-- Range FILTER -->
            <multiselect
              v-model="rangeFilter"
              :disabled="false"
              placeholder="All numbers"
              class="flex-options hide-tags no-selected-background range-filter up-down left-10 right-align sb2-bordered sb2-hoverable sb2-focusable"
              :options="rangeFilterOptions"
              label="name"
              track-by="alias"
              :multiple="false"
              :show-labels="false"
              :show-no-results="false"
              :close-on-select="true"
              :clear-on-select="false"
              :preserve-search="true"
              :allow-empty="false"
              :searchable="false"
              :preselect-first="true" >
              <template
                slot="option"
                slot-scope="props">
                <SBIcon
                  :icon="SBIconList.DONE_TICK"
                  :color="SBColors.bluePrimary"
                  :size="9"/>
                <span class="ellipsis">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </div>

          <!-- Number FILTER -->
          <FilterSingle
            v-model="numbersFilter"
            :items="numbersToFilter"
            track-by="id"
            label="name"
            sub-label="phone"
            track-icon="icon"
            group-title="Numbers"
            placement="right"
            :show-prefix-icon="false"
            :show-prefix-tick="false" />
        </div>
      </b-col>
    </b-row>
    <b-row
      v-if="!noPermission && !forbidden"
      class="top-border mt-0" />
    <b-row
      v-if="!noPermission && !forbidden"
      class="mt-0 ml-0 mr-0">
      <b-col
        v-if="numberOfBusinesses"
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          title="Total messages"
          report-title="Messages"
          height="500"
          :force-loader="loadingData || loadingContactsData"
          :no-data-if-zero="false"
          :start-date="startDate"
          :end-date="endDate"
          :hourly="rangeFilter && rangeFilter.alias === 'hour'"
          :hover-right-corner-detail="timezoneDetails"
          :chart-series="chartsData.messages.chartSeries"
          :data-series="chartsData.messages.dataSeries"
          :details-elements="chartsData.messages.chartDetails"
          :resolution="rangeFilter ? rangeFilter.alias : null" />
      </b-col>
      <b-col
        v-if="numberOfBusinesses"
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          title="Total conversations"
          report-title="Conversations"
          height="500"
          :force-loader="loadingData || loadingContactsData"
          :no-data-if-zero="false"
          :start-date="startDate"
          :hourly="rangeFilter && rangeFilter.alias === 'hour'"
          :end-date="endDate"
          :hover-right-corner-detail="timezoneDetails"
          :chart-series="chartsData.conversations.chartSeries"
          :data-series="chartsData.conversations.dataSeries"
          :details-elements="chartsData.conversations.chartDetails"
          :resolution="rangeFilter ? rangeFilter.alias : null" />
      </b-col>
      <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          title="Total new contacts"
          report-title="Contacts"
          height="500"
          :force-loader="loadingData || loadingContactsData"
          :no-data-if-zero="false"
          :start-date="startDate"
          :end-date="endDate"
          :hourly="rangeFilter && rangeFilter.alias === 'hour'"
          :hover-right-corner-detail="timezoneDetails"
          :chart-series="chartsData.contacts.chartSeries"
          :data-series="chartsData.contacts.dataSeries"
          :details-elements="chartsData.contacts.chartDetails"
          :resolution="rangeFilter ? rangeFilter.alias : null" />
      </b-col>
      
      <!-- Integration charts - Add some check if these need to be shown -->
      <template
        v-if="numberOfBusinesses">
      
        <template
          v-for="(integration, index) in integrationsInFocus">
          <b-col
            v-if="integrationsChartsData[integration.code]"
            :key="index"
            lg="6"
            xl="4"
            class="chart-wrapper" >
            <SbApexChart
              :title="integrationsChartsData[integration.code].title"
              :report-title="`integration:${integration.code}`"
              value-suffix="%"
              height="500"
              :force-loader="loadingData || loadingContactsData || !integrationsChartsData[integration.code].chartSeries || !integrationsChartsData[integration.code].chartSeries[0] || !integrationsChartsData[integration.code].chartSeries[0].data || !integrationsChartsData[integration.code].chartSeries[0].data.length"
              :start-date="startDate"
              :end-date="endDate"
              :percentage="true"
              :no-data-if-zero="false"
              :no-activity-zero="true"
              :hourly="rangeFilter && rangeFilter.alias === 'hour'"
              :hover-right-corner-detail="timezoneDetails"
              :chart-series="integrationsChartsData[integration.code].chartSeries"
              :data-series="integrationsChartsData[integration.code].dataSeries"
              :details-elements="integrationsChartsData[integration.code].chartDetails"
              :resolution="rangeFilter ? rangeFilter.alias : null" />
          </b-col>
        </template>
      </template>

      <b-col
        v-if="numberOfBusinesses"
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          title="AVERAGE REPLY TIME"
          report-title="average reply time"
          height="500"
          :force-loader="loadingData || loadingContactsData"
          :no-data-if-zero="false"
          :start-date="startDate"
          :end-date="endDate"
          :time-values="true"
          :show-max-detail="true"
          :hourly="rangeFilter && rangeFilter.alias === 'hour'"
          :hover-right-corner-detail="timezoneDetails"
          :chart-series="chartsData.averageFirstReply.chartSeries"
          :data-series="chartsData.averageFirstReply.dataSeries"
          :details-elements="chartsData.averageFirstReply.chartDetails"
          :resolution="rangeFilter ? rangeFilter.alias : null" />
      </b-col>
      <b-col
        v-if="numberOfBusinesses"
        lg="6"
        xl="4"
        class="chart-wrapper"
        @mousemove="moveMemberPopover"
        @mouseleave="leaveMemberPopover" >
        <h3 class="sb2-chart-title">
          <span class="ellipsis">TEAM MEMBERS ACTIVITY</span>
          <router-link
            :to="{ name: 'Report', params: { section: 'members' } }"
            class="report-btn"
            tag="span">
            VIEW REPORT
          </router-link>
        </h3>
        <b-popover
          target="member-value-0"
          triggers="manual"
          placement="top"
          custom-class="basic-popover"
          :show.sync="showMemberPopover">
          Total conversations
        </b-popover>
        <div
          v-if="loadingData || loadingContactsData || !membersTableData.length"
          class="member-loader flex column center-all" >
          <div class="member-loader-wrapper flex center-all">
            <ChartLoader
              width="28" />
          </div>
          <p>Loading data</p>
        </div>
        <template v-else>
          <div
            v-for="(member, index) in membersTableData"
            :key="index"
            class="member-item flex center-all border-bottom" >
            <SBAvatar
              class="no-shrink avatar"
              size="xs-button"
              :show-data="true"
              :character-count="1"
              :person="member.member"
              :show-client="true" />
            <span class="member-name greedy ellipsis">{{ member.name }}</span>
            <span
              :id="`member-value-${index}`"
              class="member-value"
              data-show>{{ member.value }}</span>
          </div>
          <!-- Show if more than 4 members -->
          <router-link
            v-if="membersInFocus.length > 4"
            :to="{ name: 'Report', params: { section: 'members' } }"
            class="report-btn y-padding-15"
            tag="div">
            <div
              class="member-item show-hand flex center-all border-top"
              @mouseover="moreMembersHover = true"
              @mouseleave="moreMembersHover = false" >
              <SBIcon
                :active="moreMembersHover"
                :icon="SBIconList.PLUS"
                :color="SBColors.white"
                :background-color="SBColors.greyLight"
                :size="6"
                :hover-size="20"
                :border-radius="20"
                :hover-color="SBColors.blackPrimary" />
              <span
                class="members-left greedy">{{ membersInFocus.length - 4 }} more</span>
            </div>
          </router-link>
        </template>
      </b-col>
      <!-- <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          type="bar"
          :force-loader="loadingData"
          :start-date="startDate"
          :end-date="endDate"
          :chart-series="chartsData.averageResolution.chartSeries"
          :categories="['0 - 24h', '1 - 3d', '3 - 7d', '> 7d']"
          :resolution="rangeFilter ? rangeFilter.alias : null"
          title="AVERAGE RESOLUTION TIME"
          height="500" />
      </b-col> -->

    </b-row>

    <!-- Fake charts -->
    <!-- <b-row class="ml-0 mr-0">
      <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          :chart-series="messagesChartSeries2"
          :data-series="messagesDataSeries2"
          title="Total messages"
          height="500"
          :details-elements="messagesChartDetails2" />
      </b-col>
      <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          :chart-series="[]"
          :data-series="messagesDataSeries3"
          title="Total conversations"
          height="500"
          :details-elements="messagesChartDetails3" />
      </b-col>
      <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          :chart-series="messagesChartSeries6"
          :data-series="messagesDataSeries6"
          title="Total contacts"
          height="500"
          :details-elements="messagesChartDetails6" />
      </b-col>
      <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          type="bar"
          :show-error="true"
          :chart-series="conversationsChartSeries4"
          :data-series="conversationsDataSeries4"
          :categories="['0 - 24h', '1 - 3d', '3 - 7d', '> 7d']"
          title="AVERAGE RESOLUTION TIME"
          height="500" />
      </b-col>
      <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          type="bar"
          :chart-series="conversationsChartSeries4"
          :data-series="conversationsDataSeries4"
          :categories="['0 - 1h', '1 - 8h', '8 - 24h', '> 24h']"
          title="AVERAGE FIRST REPLY TIME"
          height="500" />
      </b-col>
      <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          :chart-series="rightmoveconversionSeries"
          :data-series="rightmoveconversionDataSeries"
          title="RIGHTMOVE CONVERSION RATE"
          height="500"
          :details-elements="rightmoveconversionChartDetails" />
      </b-col> -->
      <!-- <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          :chart-series="rightmoveconversionSeries"
          :data-series="rightmoveconversionDataSeries"
          title="ZOOPLA CONVERSION RATE"
          height="500"
          :details-elements="rightmoveconversionChartDetails" />
      </b-col>
      <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          :chart-series="messagesChartSeries2"
          :data-series="rightmoveconversionDataSeries"
          title="ONTHEMARKET CONVERSION RATE"
          height="500"
          :details-elements="rightmoveconversionChartDetails" />
      </b-col> -->
      <!-- <b-col
        lg="6"
        xl="4"
        class="chart-wrapper" >
        <SbApexChart
          type="bar"
          :chart-series="conversationsChartSeries4"
          :data-series="conversationsDataSeries4"
          :categories="['0 - 1 hours', '1 - 8 hours', '8 - 24 hours', '> 24 hours']"
          title="AVERAGE FIRST REPLY TIME"
          height="500" />
      </b-col> -->
      <!-- <b-col
        md="6"
        class="chart-wrapper" >
        <SbApexChart
          type="bar"
          :chart-series="conversationsChartSeries5"
          :data-series="conversationsDataSeries5"
          :categories="['0-1 hours', '1-8 hours', '8-24 hours', '24-48 hours', '>48 hours']"
          title="dummy bar 5"
          height="500" />
      </b-col>
      <b-col
        md="6"
        class="chart-wrapper" >
        <SbApexChart
          type="bar"
          :chart-series="conversationsChartSeries8"
          :data-series="conversationsDataSeries8"
          :categories="['0-1 hours', '1-8 hours', '8-24 hours', '24-48 hours', '48-72 hours', '72-96 hours', '96-120 hours', '>120 hours']"
          title="dummy bar 8"
          height="500" />
      </b-col>
      <b-col
        md="6"
        class="chart-wrapper" >
        <SbApexChart
          type="bar"
          :chart-series="conversationsChartSeries9"
          :data-series="conversationsDataSeries9"
          :categories="['0-1 hours', '1-8 hours', '8-24 hours', '24-48 hours', '48-72 hours', '72-96 hours', '96-120 hours', '>120 hours', 'even more']"
          title="dummy bar 9"
          height="500" />
      </b-col> -->
      <!-- <b-col
        md="6"
        class="chart-wrapper" >
        <SbApexChart
          :chart-series="messagesChartSeries"
          :data-series="messagesDataSeries"
          title="Total messages"
          height="500"
          :details-elements="messagesChartDetails" />
      </b-col> -->
    <!-- </b-row> -->
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';

import SbApexChart from '@/components/business/analytics/charts/SbApexChart';
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import DatePicker from '@/components/common/DatePicker';
import FilterSingle from '@/components/common/FilterSingle';
import api from '@/helpers/api';
import ToasterMixin from '@/mixins/Toaster';
import SBAvatar from '../../common/Avatar';
import ChartLoader from '@/components/animatedIcons/ChartLoader';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import NoPermissionMixin from '@/mixins/AccessPermission';

export default {
  name: 'Insights',
  components: {
    SbApexChart,
    SBIcon,
    Multiselect,
    DatePicker,
    FilterSingle,
    SBAvatar,
    ChartLoader,
  },
  mixins: [
    ToasterMixin,
    UserPermissionsMixin,
    NoPermissionMixin,
  ],
  data() {
    return {
      preventDataFetch: false,
      moreMembersHover: false,
      timeFilter: '',
      startDate: null,
      endDate: null,
      rangeFilter: null,
      initialized: false,
      showMemberPopover: false,
      numbersFilter: [],
      hideModes: [],
      membersTableData: [],
      loadingData: false,
      loadingContactsData: false,
      byHour: false,
      averageFirstReplySlots: [
        '0 - 1 hours',
        '1 - 8 hours',
        '8 - 24 hours',
        '> 24 hours',
      ],
      averageResolutionSlots: [
        '0-24',
        '24-72',
        '72-168',
        '>168',
      ],
      timeFilterOptions: [
        {
          alias: 'date',
          name: 'Today',
        },
        {
          alias: 'list',
          name: 'This week',
        },
        {
          alias: 'email',
          name: 'Last week',
        },
        {
          alias: 'list',
          name: 'This month',
        },
        {
          alias: 'email',
          name: 'Last month',
        },
        {
          alias: 'list',
          name: 'This year',
        },
        {
          alias: 'email',
          name: 'All time',
        },
      ],
      SBColors,
      SBIconList,
      integrationsChartsData: {},
      chartsData: {
        messages: {
          chartSeries: null,
          chartDetails: [
            { name: 'in', text: 'inbound' },
            {
              name: 'out',
              text: 'outbound',
            },
            // {
            //   name: 'bot',
            //   text: 'bot',
            // },
          ],
          dataSeries: null,
        },
        conversations: {
          chartSeries: null,
          chartDetails: [
            {
              name: 'bic',
              text: 'bic',
            },
            {
              name: 'uic',
              text: 'uic',
            },
            // {
            //   name: 'new',
            //   text: 'new',
            // },
            // {
            //   name: 'fep',
            //   text: 'fep',
            // },
          ],
          dataSeries: null,
        },
        contacts: {
          chartSeries: null,
          // chartDetails: [
          //   { name: 'new', text: 'new' },
          // ],
          dataSeries: null,
        },
        averageFirstReply: {
          chartSeries: null,
          chartDetails: [
            {
              name: '0 - 1h',
              text: '0 - 1h',
            },
            {
              name: '1 - 8h',
              text: '1 - 8h',
            },
            {
              name: '8 - 24h',
              text: '8 - 24h',
            },
            {
              name: '> 24h',
              text: '> 24h',
            },
          ],
        },
        averageResolution: {
          chartSeries: null,
        },
        // INTEGRATION
        rightMove: {
          chartSeries: null,
          chartDetails: [
            { name: 'contacted', text: 'contacted' },
            { name: 'replied', text: 'replied' },
          ],
          dataSeries: null,
        },
        onTheMarket: {
          chartSeries: null,
          chartDetails: [
            { name: 'contacted', text: 'contacted' },
            { name: 'replied', text: 'replied' },
          ],
          dataSeries: null,
        },
        zoopla: {
          chartSeries: null,
          chartDetails: [
            { name: 'contacted', text: 'contacted' },
            { name: 'replied', text: 'replied' },
          ],
          dataSeries: null,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
      currentOrganisationMembers: 'organisation/currentOrganisationMembers',
      currentOrganisationMembersLookup: 'organisation/currentOrganisationMembersLookup',
      currentOrganisationBusinesses: 'organisation/currentOrganisationBusinesses',
      // organisationTeams: 'organisation/organisationTeams',
      datePickerResolution: 'helpers/datePickerResolution',
      datePickerNumbersFilter: 'helpers/datePickerNumbersFilter',
      currentOrganisationIntegrations: 'organisation/currentOrganisationIntegrations',
      // userRegion: 'user/region',
      numberIntegrationMap: 'organisation/numberIntegrationMap',
      showAnnouncement: 'system/showAnnouncement',
    }),
    isMonthMode() {
      return this.rangeFilter && this.rangeFilter.alias === 'month';
    },
    isWeekMode() {
      return this.rangeFilter && this.rangeFilter.alias === 'week';
    },
    membersInFocus() {
      let userIds = [];
      if (this.numbersFilter.length) {
        this.currentOrganisationMembers.forEach((member) => {
          if (this.numbersFilter.some(filteredNumber => member.businesses.includes(filteredNumber))) {
            userIds.push(member.id);
          }
        });
      } else {
        userIds = this.currentOrganisationMembers.map(member => member.id);
      }

      return userIds;
    },
    noPermission() {
      return !this.checkPermission('view_analytics');
    },
    numberOfBusinesses() {
      return this.currentOrganisationBusinesses.length;
    },
    numbersToFilter() {
      const businessesWithEmoji = this.currentOrganisationBusinesses.map((number, index) => {
        const item = {
          id: number.id,
          name: number.name,
          phone: number.phone,
          icon: number.emoji,
        };
        if (this.numberIntegrationMap[number.id] && this.numberIntegrationMap[number.id].length === 1) {
          delete item.icon;
          item.integration = this.numberIntegrationMap[number.id][0];
        } else if (this.numberIntegrationMap[number.id] && this.numberIntegrationMap[number.id].length) {
          delete item.icon;
          item.integrationCount = this.numberIntegrationMap[number.id].length;
        }
        return item;
      });
      return businessesWithEmoji;
    },
    rangeFilterOptions() {
      const rangeFilterOptions = [
        {
          alias: 'hour',
          name: 'Hourly',
        },
        {
          alias: 'day',
          name: 'Daily',
        },
        {
          alias: 'week',
          name: 'Weekly',
        },
        {
          alias: 'month',
          name: 'Monthly',
        },
      ];
      return rangeFilterOptions.filter(option => !this.hideModes.includes(option.alias));
    },
    timezoneDetails() {
      const timezone = this.currentOrganisation.timezone.split('/');
      return timezone[1] ? `${timezone[1]} time` : timezone.length ? `${timezone[0]} time` : 'UTC time';
    },
    integrationsInFocus() {
      let integrations = [];
      const integrationCodesAdded = [];
      if (this.numbersFilter.length) {
        this.currentOrganisationIntegrations.forEach((integration) => {
          if (
            integration.measure_conversion_rate &&
            !integrationCodesAdded.includes(integration.code) &&
            this.numbersFilter.some(filteredNumber => integration.business_ids.includes(filteredNumber))
          ) {
            integrations.push(integration);
            integrationCodesAdded.push(integration.code);
          }
        });
      } else {
        integrations = [...this.currentOrganisationIntegrations.filter(integration => integration.measure_conversion_rate)];
        integrations = this.$lodash.uniqBy(integrations, 'code');
      }

      return integrations;
    },
  },
  watch: {
    rangeFilter(newValue, oldValue) {
      this.setDatePickerResolution(this.rangeFilter.alias);
      // Change on the range changes setup for the datePicker which then recalculates dates and emits change which triggers activity request.
      if (oldValue && this.initialized) {
        this.showToaster(`<span class="emoji-fix">📅</span> Calendar was updated to ${this.rangeFilter.alias} range.`);
      }

      this.$nextTick(() => {
        this.getActivityData();
      });
    },
    numbersFilter() {
      this.satNumbersFilter(this.numbersFilter);
      this.getActivityData();
    },
    hideModes(newValue, oldValue) {
      if (this.hideModes.includes(this.rangeFilter.alias)) {
        this.rangeFilter = this.rangeFilterOptions[0];
      }

      if (oldValue && this.initialized) {
        this.showToaster(`<span class="emoji-fix">↕️</span> View was updated to ${this.rangeFilter.name}.`);
      }
    },
    integrationsInFocus() {
      this.integrationsInFocus.forEach((integration) => {
        this.integrationsChartsData[integration.code] = {
          title: `${integration.name} CONVERSION RATE`,
          chartDetails: [
            { name: 'contacted', text: 'contacted' },
            { name: 'replied', text: 'replied' },
          ],
          chartSeries: [{
            name: 'data',
            data: [],
          }],
          dataSeries: [{
            name: 'data',
            data: [],
          }],
        };
      });

      this.integrationsChartsData = { ...this.integrationsChartsData };
    },
  },
  beforeMount() {
    if (this.datePickerNumbersFilter.length) {
      this.numbersFilter = this.datePickerNumbersFilter;
    }

    this.integrationsInFocus.forEach((integration) => {
      this.integrationsChartsData[integration.code] = {
        title: `${integration.name} CONVERSION RATE`,
        chartDetails: [
          { name: 'contacted', text: 'contacted' },
          { name: 'replied', text: 'replied' },
        ],
        chartSeries: [{
          name: 'data',
          data: [],
        }],
        dataSeries: [{
          name: 'data',
          data: [],
        }],
      };
    });

    this.integrationsChartsData = { ...this.integrationsChartsData };
  },
  mounted() {
    if (this.datePickerResolution) {
      this.rangeFilter = this.rangeFilterOptions.find(option => option.alias === this.datePickerResolution);
    }

    this.finalizeSplashView();
    this.getActivityData();

    // console.log(this.$moment().utcOffset());
    // console.log(this.$moment().parseZone());
    // console.log(this.$moment(null, false).tz.guess());

    setTimeout(() => {
      this.initialized = true;
    }, 0);
  },
  methods: {
    ...mapActions({
      finalizeSplashView: 'organisation/finalizeSplashView',
      setDatePickerResolution: 'helpers/setDatePickerResolution',
      satNumbersFilter: 'helpers/satNumbersFilter',
    }),
    dateRangeChange(range) {
      if (this.rangeFilter.alias === 'week') {
        this.startDate = range[0].startOf('day').unix();
        this.endDate = range[1].endOf('week').endOf('day').unix();
      } else if (this.rangeFilter.alias === 'month') {
        this.startDate = range[0].startOf('day').unix();
        this.endDate = range[1].endOf('month').endOf('day').unix();
      } else {
        this.startDate = range[0].startOf('day').unix();
        this.endDate = range[1].endOf('day').unix();
      }

      const newHideModes = [];
      const differenceInHours = range[1].diff(range[0], 'hours');

      // Hide modes if they are too detail for the selected range
      // --------------------------------------------------------------------------------
      // Hide 'hourly' if difference is more than 48 hours
      if (differenceInHours >= 48) {
        newHideModes.push('hour');
      }

      // Hide 'daily' if more than 90 days are selected
      if (differenceInHours >= (24 * 90)) {
        newHideModes.push('day');
      }

      // Hide 'weekly' if more than 50 weeks are selected
      if (differenceInHours >= (24 * 7 * 50)) {
        newHideModes.push('week');
      }

      // Also, hide modes if they are too wide for selected range.
      // E.g. There is no reason 'montly' should be available if user only selected
      //      5 days from the calendar.
      // --------------------------------------------------------------------------------
      // Hide 'montly' if difference is less than 45 days
      if (differenceInHours < (24 * 45)) {
        newHideModes.push('month');
      }

      // Hide 'weekly' if difference is less than 14 days
      if (differenceInHours < (24 * 14)) {
        newHideModes.push('week');
      }

      // Hide 'daily' if difference is less than 24 hours
      if (differenceInHours < 24) {
        newHideModes.push('day');
      }

      if (newHideModes.toString() !== this.hideModes.toString()) {
        this.hideModes = newHideModes;
      }

      this.$nextTick(() => {
        this.getActivityData();
      });
    },
    getActivityData() {
      if (this.preventDataFetch || !this.startDate || !this.endDate || !this.rangeFilter) {
        return;
      }
      // TODO this is not done - finish it once org timezone is available
      // console.log(this.startDate, this.$moment(false, false).unix(this.startDate));
      // console.log(this.endDate, this.$moment(false, false).unix(this.endDate));
      const startDate = this.$moment(false, false).unix(this.startDate);
      const endDate = this.$moment(false, false).unix(this.endDate);
      // console.log(startDate.date(), startDate.month(), startDate.year());
      // console.log(endDate.startOf('day'), endDate.endOf('day'));
      this.byHour = false;
      if (this.rangeFilter.alias === 'day' && startDate.date() === endDate.date() && startDate.month() === endDate.month() && startDate.year() === endDate.year()) {
        startDate.startOf('day');
        endDate.endOf('day');
        this.byHour = true;
        // console.log('UNIX', startDate.unix());
      } else if (this.rangeFilter.alias === 'month' && startDate.month() === endDate.month() && startDate.year() === endDate.year()) {
        startDate.startOf('month');
        endDate.endOf('month');
        // console.log('Month UNIX', startDate.unix());
      }
      this.loadingData = true;
      this.loadingContactsData = true;
      this.membersTableData = [];
      const userIds = this.membersInFocus.join(',');

      // Check if users are available. If not, then the members endpoint is not finished yet so try again in a second.
      if (!userIds.length) {
        setTimeout(() => {
          this.getActivityData();
        }, 1000);
        return;
      }

      // GET /w/organisation/<str:organisation_uid>/analytics
      // GET /w/organisation/<str:organisation_uid>/business/<str:business_uid>/analytics
      // ?time_zone=Europe%2FZagreb&date_point=day&start_date=1643756400&end_date=1644330840
      const options = {
        // time_zone: 'Europe%2FZagreb',
        date_point: this.rangeFilter.alias,
        start_date: this.rangeFilter.alias === 'day' ? startDate.unix() : startDate.tz(this.currentOrganisation.timezone).unix(), // + (this.$moment().utcOffset() * 60),
        end_date: this.rangeFilter.alias === 'day' ? endDate.endOf('day').unix() : endDate.endOf('day').tz(this.currentOrganisation.timezone).unix(), // + (this.$moment().utcOffset() * 60),
        // user_ids: userIds, // this breaks the API call because of URI too long error and it doesn't seem to be needed
      };
      if (this.numbersFilter.length) {
        options.business_ids = this.numbersFilter.toString();
      }

      this.preventDataFetch = true;
      if (!this.numberOfBusinesses) {
        this.loadingData = false;
        this.loadingContactsData = false;
      } else {
        api('GET', `/organisation/${this.currentOrganisation.id}/analytics`, options, null, 'w')
          .then((response) => {
            if (response.status === 200) {
              // response.data['332eba98-3011-4cb8-85d7-bc7e1a3f852d'].integrations = {
              // "Right Move": {
              //     "2022-6-1": {
              //         "count": 242,
              //         "answered_count": 140
              //     },
              //     "2022-6-2": {
              //         "count": 310,
              //         "answered_count": 156
              //     },
              //     "2022-6-3": {
              //         "count": 309,
              //         "answered_count": 171
              //     },
              //     "2022-6-4": {
              //         "count": 428,
              //         "answered_count": 246
              //     },
              //     "2022-6-5": {
              //         "count": 114,
              //         "answered_count": 146
              //     }
              // },
              // "Zoopla": {
              //     "2022-6-1": {
              //         "count": 149,
              //         "answered_count": 89
              //     },
              //     "2022-6-2": {
              //         "count": 158,
              //         "answered_count": 75
              //     },
              //     "2022-6-3": {
              //         "count": 196,
              //         "answered_count": 105
              //     },
              //     "2022-6-4": {
              //         "count": 233,
              //         "answered_count": 130
              //     },
              //     "2022-6-5": {
              //         "count": 93,
              //         "answered_count": 77
              //     }
              // },
              // "Right Move Valuation": {
              //     "2022-6-1": {
              //         "count": 1,
              //         "answered_count": 0
              //     },
              //     "2022-6-2": {
              //         "count": 4,
              //         "answered_count": 1
              //     },
              //     "2022-6-3": 0,
              //     "2022-6-4": {
              //         "count": 2,
              //         "answered_count": 0
              //     },
              //     "2022-6-5": 0
              // }
              // };
              this.processChartData(response.data);
            }
          })
          .catch((error) => {
            this.error = error.response;
          });
      }

      api('GET', `/organisation/${this.currentOrganisation.id}/analytics/contacts`, options, null, 'w')
        .then((response) => {
          if (response.status === 200) {
            this.processChartContactsData(response.data);
          }
        })
        .catch((error) => {
          this.error = error.response;
        });

      setTimeout(() => {
        this.preventDataFetch = false;
      }, 100);
    },
    convertToUnixDate(insightsDate) {
      let unixDate;
      const dateArray = insightsDate.split('-');
      switch (this.rangeFilter.alias) {
        case 'month':
          unixDate = this.$moment().year(dateArray[0]).month(dateArray[1] - 1).unix();
          break;
        case 'week':
          // console.log('w', dateArray[0], dateArray[1], this.$moment().year(dateArray[0]).isoWeek(dateArray[1]).day(0));
          unixDate = this.$moment().year(dateArray[0]).isoWeek(dateArray[1]).weekday(0).unix();
          // .tz("America/Toronto")
          break;
        case 'day':
          dateArray[1] -= 1; // month must be zero based so we have to decrease it by one
          unixDate = this.$moment(dateArray).unix();
          break;
        default: // hour
          dateArray[1] -= 1; // month must be zero based so we have to decrease it by one
          unixDate = this.$moment(dateArray.slice(0, 3)).hour(dateArray[3]).unix();
          break;
      }

      return unixDate;
    },
    processChartContactsData(analyticsChartData) {
      const totalContactsPerDatePoint = {};
      const totalContactsTypePerDatePoint = {};

      const datePoints = [...Object.keys(analyticsChartData)];

      datePoints.forEach((datePoint) => {
        if (!totalContactsPerDatePoint[datePoint]) {
          totalContactsPerDatePoint[datePoint] = 0;
          totalContactsTypePerDatePoint[datePoint] = {
            date: this.convertToUnixDate(datePoint),
            new: 0,
          };
        }
        totalContactsPerDatePoint[datePoint] += Number(analyticsChartData[datePoint]);
      });

      this.chartsData.contacts = {
        ...this.chartsData.contacts,
        ...{
          chartSeries: [{
            name: 'data',
            data: Object.values(totalContactsPerDatePoint),
          }],
        },
        ...{
          dataSeries: [{
            name: 'data',
            data: Object.values(totalContactsTypePerDatePoint),
          }],
        },
      };

      this.loadingContactsData = false;
    },
    processChartData(analyticsData) {
      let datePoints = [];
      let numbers = Object.keys(analyticsData);
      numbers = numbers.filter(number => number !== 'date_points');

      datePoints = analyticsData.date_points;

      // Members table data START
      const memberCount = {};
      this.membersInFocus.forEach((memberId) => {
        memberCount[memberId] = 0;
      });

      numbers.forEach((number) => {
        const members = Object.keys(analyticsData[number].conversations.members);
        members.forEach((member) => {
          if (!memberCount[member]) {
            memberCount[member] = 0;
          }
          memberCount[member] += Object.values(analyticsData[number].conversations.members[member]).reduce((prev, curr) => prev + curr, 0);
        });
      });

      Object.keys(memberCount).forEach((memberId) => {
        this.membersTableData.push({
          name: this.currentOrganisationMembersLookup[memberId].name,
          value: memberCount[memberId],
          member: this.currentOrganisationMembersLookup[memberId],
        });
      });
      this.membersTableData = this.membersTableData.sort((a, b) => b.value - a.value).slice(0, 4);
      // Members table data END

      const totalMessagesPerDatePoint = {};
      const totalMessagesTypePerDatePoint = {};

      const totalConversationsPerDatePoint = {};
      const totalConversationsTypePerDatePoint = {};

      const totalContactsPerDatePoint = {};
      const totalContactsTypePerDatePoint = {};

      // averageFirstReply
      const averageFirstReplyPerDatePoint = {};
      const averageFirstReplyTypePerDatePoint = {};

      // averageResolution
      const averageResolutionPerDatePoint = {};

      const totalRightMovePerDatePoint = {};
      const totalRightMoveTypePerDatePoint = {};

      const totalOnTheMarketPerDatePoint = {};
      const totalOnTheMarketTypePerDatePoint = {};

      const totalZooplaPerDatePoint = {};
      const totalZooplaTypePerDatePoint = {};

      numbers.forEach((number) => {
        const numberData = analyticsData[number];
        datePoints.forEach((datePoint) => {
          if (!totalMessagesPerDatePoint[datePoint]) {
            totalMessagesPerDatePoint[datePoint] = 0;
            totalMessagesTypePerDatePoint[datePoint] = {
              date: this.convertToUnixDate(datePoint),
              in: 0,
              out: 0,
              // bot: 0,
            };
          }
          totalMessagesPerDatePoint[datePoint] += Number(numberData.messages.inbound[datePoint] || 0) + Number(numberData.messages.outbound[datePoint] || 0);
          totalMessagesTypePerDatePoint[datePoint].in += Number(numberData.messages.inbound[datePoint] || 0);
          totalMessagesTypePerDatePoint[datePoint].out += Number(numberData.messages.outbound[datePoint] || 0);
          // totalMessagesTypePerDatePoint[datePoint].bot += Number(numberData.messages.bot[datePoint] || 0);

          if (!totalConversationsPerDatePoint[datePoint]) {
            totalConversationsPerDatePoint[datePoint] = 0;
            totalConversationsTypePerDatePoint[datePoint] = {
              date: this.convertToUnixDate(datePoint),
              bic: 0,
              uic: 0,
              new: 0,
              fep: 0,
            };
          }

          let bicValue = 0;
          let uicValue = 0;

          const bicKeys = Object.keys(numberData.conversations.channels.whatsapp.BIC);
          bicKeys.forEach((bicKey) => {
            if (numberData.conversations.channels.whatsapp.BIC[bicKey][datePoint]) {
              bicValue += numberData.conversations.channels.whatsapp.BIC[bicKey][datePoint];
            }
          });

          const uicKeys = Object.keys(numberData.conversations.channels.whatsapp.UIC);
          uicKeys.forEach((uicKey) => {
            if (numberData.conversations.channels.whatsapp.UIC[uicKey][datePoint]) {
              uicValue += numberData.conversations.channels.whatsapp.UIC[uicKey][datePoint];
            }
          });

          totalConversationsPerDatePoint[datePoint] += bicValue + uicValue;
          totalConversationsTypePerDatePoint[datePoint].bic += bicValue;
          totalConversationsTypePerDatePoint[datePoint].uic += uicValue;
        });

        // averageFirstReplySlots
        datePoints.forEach((datePoint) => {
          if (!averageFirstReplyPerDatePoint[datePoint]) {
            averageFirstReplyPerDatePoint[datePoint] = 0;
            averageFirstReplyTypePerDatePoint[datePoint] = {
              date: this.convertToUnixDate(datePoint),
              '0 - 1h': 0,
              '1 - 8h': 0,
              '8 - 24h': 0,
              '> 24h': 0,
              'TMP 0 - 1h': {
                count: 0,
                seconds: 0,
              },
              'TMP 1 - 8h': {
                count: 0,
                seconds: 0,
              },
              'TMP 8 - 24h': {
                count: 0,
                seconds: 0,
              },
              'TMP > 24h': {
                count: 0,
                seconds: 0,
              },
              totalCount: 0,
              totalSeconds: 0,
            };
          }
          if (numberData.average_reply_time.seconds[datePoint]) {
            averageFirstReplyPerDatePoint[datePoint] += Number(numberData.average_reply_time.seconds[datePoint].seconds || 0);

            averageFirstReplyTypePerDatePoint[datePoint].totalCount += Number(numberData.average_reply_time.seconds[datePoint].count || 0);
            averageFirstReplyTypePerDatePoint[datePoint].totalSeconds += Number(numberData.average_reply_time.seconds[datePoint].seconds || 0);

            averageFirstReplyTypePerDatePoint[datePoint]['TMP 0 - 1h'].count += Number(numberData.average_reply_time.slot['0 - 1 hours'] ? numberData.average_reply_time.slot['0 - 1 hours'][datePoint] : 0);
            averageFirstReplyTypePerDatePoint[datePoint]['TMP 1 - 8h'].count += Number(numberData.average_reply_time.slot['1 - 8 hours'] ? numberData.average_reply_time.slot['1 - 8 hours'][datePoint] : 0);
            averageFirstReplyTypePerDatePoint[datePoint]['TMP 8 - 24h'].count += Number(numberData.average_reply_time.slot['8 - 24 hours'] ? numberData.average_reply_time.slot['8 - 24 hours'][datePoint] : 0);
            averageFirstReplyTypePerDatePoint[datePoint]['TMP > 24h'].count += Number(numberData.average_reply_time.slot['> 24 hours'] ? numberData.average_reply_time.slot['> 24 hours'][datePoint] : 0);

            if (numberData.average_reply_time.seconds[datePoint].seconds <= 3600) { // less than 1 hour
              // averageFirstReplyTypePerDatePoint[datePoint]['TMP 0 - 1h'].count += Number(numberData.average_reply_time.seconds[datePoint].count || 0);
              averageFirstReplyTypePerDatePoint[datePoint]['TMP 0 - 1h'].seconds += Number(numberData.average_reply_time.seconds[datePoint].seconds || 0);
              // averageFirstReplyTypePerDatePoint[datePoint]['0 - 1h'] = averageFirstReplyTypePerDatePoint[datePoint]['TMP 0 - 1h'].count ? averageFirstReplyTypePerDatePoint[datePoint]['TMP 0 - 1h'].count / averageFirstReplyTypePerDatePoint[datePoint].totalCount : 0;
            } else if (numberData.average_reply_time.seconds[datePoint].seconds <= 28800) { // less than 8 hours
              // averageFirstReplyTypePerDatePoint[datePoint]['TMP 1 - 8h'].count += Number(numberData.average_reply_time.seconds[datePoint].count || 0);
              averageFirstReplyTypePerDatePoint[datePoint]['TMP 1 - 8h'].seconds += Number(numberData.average_reply_time.seconds[datePoint].seconds || 0);
              // averageFirstReplyTypePerDatePoint[datePoint]['1 - 8h'] = averageFirstReplyTypePerDatePoint[datePoint]['TMP 1 - 8h'].count ? averageFirstReplyTypePerDatePoint[datePoint]['TMP 1 - 8h'].count / averageFirstReplyTypePerDatePoint[datePoint].totalCount : 0;
            } else if (numberData.average_reply_time.seconds[datePoint].seconds <= 86400) { // less than 24 hours
              // averageFirstReplyTypePerDatePoint[datePoint]['TMP 8 - 24h'].count += Number(numberData.average_reply_time.seconds[datePoint].count || 0);
              averageFirstReplyTypePerDatePoint[datePoint]['TMP 8 - 24h'].seconds += Number(numberData.average_reply_time.seconds[datePoint].seconds || 0);
              // averageFirstReplyTypePerDatePoint[datePoint]['8 - 24h'] = averageFirstReplyTypePerDatePoint[datePoint]['TMP 8 - 24h'].count ? averageFirstReplyTypePerDatePoint[datePoint]['TMP 8 - 24h'].count / averageFirstReplyTypePerDatePoint[datePoint].totalCount : 0;
            } else { // more than 24 hours
              // averageFirstReplyTypePerDatePoint[datePoint]['TMP > 24h'].count += Number(numberData.average_reply_time.seconds[datePoint].count || 0);
              averageFirstReplyTypePerDatePoint[datePoint]['TMP > 24h'].seconds += Number(numberData.average_reply_time.seconds[datePoint].seconds || 0);
              // averageFirstReplyTypePerDatePoint[datePoint]['> 24h'] = averageFirstReplyTypePerDatePoint[datePoint]['TMP > 24h'].count ? averageFirstReplyTypePerDatePoint[datePoint]['TMP > 24h'].count / averageFirstReplyTypePerDatePoint[datePoint].totalCount : 0;
            }

            averageFirstReplyTypePerDatePoint[datePoint]['0 - 1h'] = averageFirstReplyTypePerDatePoint[datePoint]['TMP 0 - 1h'].count ? averageFirstReplyTypePerDatePoint[datePoint]['TMP 0 - 1h'].count / averageFirstReplyTypePerDatePoint[datePoint].totalCount : 0;
            averageFirstReplyTypePerDatePoint[datePoint]['1 - 8h'] = averageFirstReplyTypePerDatePoint[datePoint]['TMP 1 - 8h'].count ? averageFirstReplyTypePerDatePoint[datePoint]['TMP 1 - 8h'].count / averageFirstReplyTypePerDatePoint[datePoint].totalCount : 0;
            averageFirstReplyTypePerDatePoint[datePoint]['8 - 24h'] = averageFirstReplyTypePerDatePoint[datePoint]['TMP 8 - 24h'].count ? averageFirstReplyTypePerDatePoint[datePoint]['TMP 8 - 24h'].count / averageFirstReplyTypePerDatePoint[datePoint].totalCount : 0;
            averageFirstReplyTypePerDatePoint[datePoint]['> 24h'] = averageFirstReplyTypePerDatePoint[datePoint]['TMP > 24h'].count ? averageFirstReplyTypePerDatePoint[datePoint]['TMP > 24h'].count / averageFirstReplyTypePerDatePoint[datePoint].totalCount : 0;
          }
        });

        // // averageResolution
        // this.averageResolutionSlots.forEach((averageResolutionSlot) => {
        //   if (!averageResolutionPerDatePoint[averageResolutionSlot]) {
        //     averageResolutionPerDatePoint[averageResolutionSlot] = 0;
        //   }
        //   averageResolutionPerDatePoint[averageResolutionSlot] += Number(numberData.message_responses.total_resolution_time[averageResolutionSlot]);
        // });

        if (numberData.integrations && this.integrationsInFocus.length) {
          // Integrations are dynamic and we should print as many graphs as there are sections in integrations parameter.
          const integrations = this.integrationsInFocus;
          const integrationsData = {};
          integrations.forEach((integration) => {
            integrationsData[integration.code] = {
              datePoints: {},
              datePointDetails: {},
            };
            datePoints.forEach((datePoint) => {
              if (!integrationsData[integration.code].datePoints[datePoint]) {
                integrationsData[integration.code].datePoints[datePoint] = Number(0);
                integrationsData[integration.code].datePointDetails[datePoint] = {
                  date: this.convertToUnixDate(datePoint),
                  contacted: 0,
                  replied: 0,
                };
              }
              if (numberData.integrations && numberData.integrations[integration.code] && numberData.integrations[integration.code][datePoint]) {
                integrationsData[integration.code].datePoints[datePoint] +=
                  (Number(numberData.integrations[integration.code][datePoint].count)) > 0
                    ? Number(((Number(numberData.integrations[integration.code][datePoint].answered_count) / Number(numberData.integrations[integration.code][datePoint].count)) * 100).toFixed(2))
                    : 0;
                integrationsData[integration.code].datePointDetails[datePoint].contacted += Number(numberData.integrations[integration.code][datePoint].count) ? Number(numberData.integrations[integration.code][datePoint].count) : 0;
                integrationsData[integration.code].datePointDetails[datePoint].replied += Number(numberData.integrations[integration.code][datePoint].answered_count) ? Number(numberData.integrations[integration.code][datePoint].answered_count) : 0;
              }
            });

            this.integrationsChartsData[integration.code] = {
              title: `${integration.name} CONVERSION RATE`,
              chartDetails: [
                { name: 'contacted', text: 'contacted' },
                { name: 'replied', text: 'replied' },
              ],
              chartSeries: [{
                name: 'data',
                data: Object.values(integrationsData[integration.code].datePoints),
              }],
              dataSeries: [{
                name: 'data',
                data: Object.values(integrationsData[integration.code].datePointDetails),
              }],
            };
          });

          this.integrationsChartsData = { ...this.integrationsChartsData };
        }
      });

      datePoints.forEach((datePoint) => {
        averageFirstReplyPerDatePoint[datePoint] = averageFirstReplyTypePerDatePoint[datePoint].totalCount ? averageFirstReplyPerDatePoint[datePoint] / averageFirstReplyTypePerDatePoint[datePoint].totalCount : 0;
      });

      this.chartsData.messages = {
        ...this.chartsData.messages,
        ...{
          chartSeries: [{
            name: 'data',
            data: Object.values(totalMessagesPerDatePoint),
          }],
        },
        ...{
          dataSeries: [{
            name: 'data',
            data: Object.values(totalMessagesTypePerDatePoint),
          }],
        },
      };

      this.chartsData.conversations = {
        ...this.chartsData.conversations,
        ...{
          chartSeries: [{
            name: 'data',
            data: Object.values(totalConversationsPerDatePoint),
          }],
        },
        ...{
          dataSeries: [{
            name: 'data',
            data: Object.values(totalConversationsTypePerDatePoint),
          }],
        },
      };

      this.chartsData.averageFirstReply = {
        ...this.chartsData.averageFirstReply,
        ...{
          chartSeries: [{
            name: 'data',
            data: Object.values(averageFirstReplyPerDatePoint),
          }],
        },

        ...{
          dataSeries: [{
            name: 'data',
            data: Object.values(averageFirstReplyTypePerDatePoint),
          }],
        },
      };

      // this.chartsData.averageResolution = {
      //   ...this.chartsData.averageResolution,
      //   ...{
      //     chartSeries: [{
      //       name: 'data',
      //       data: Object.values(averageResolutionPerDatePoint),
      //     }],
      //   },
      // };

      this.loadingData = false;
    },
    moveMemberPopover(e) {
      if (e.srcElement.dataset.show || e.srcElement.dataset.show === '') {
        this.showMemberPopover = true;
      } else {
        this.showMemberPopover = false;
      }
    },
    leaveMemberPopover() {
      this.showMemberPopover = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.dashboard {
  background-color: $white;
  padding: 0 0 35px;
  overflow-x: hidden;
  overflow-y: auto;

  .title {
    margin-bottom: 12px !important;
  }

  .row {
    max-width: 1521px;

    &.sticky-top {
      background-color: $white;
    }

    .left-40 {
      padding-left: 40px;
    }

    .right-40 {
      padding-right: 40px;
    }

    .action-bar {
      margin-top: 21px;

      .settings--box {
        padding-bottom: 20px;
      }

      .range-filter {
        width: fit-content;
        &.multiselect {
          min-height: 30px !important;
        }
        ::v-deep {

          .multiselect__tags {
            padding: 0 35px 0 15px !important;
            min-height: 30px;
          }

          .multiselect__select {
            margin-right: 15px;
            height: 30px;
          }
        }
      }

      .min-130 {
        min-width: 130px;
      }
    }
  }

  ::v-deep .multiselect {
    .multiselect__single {
      font-weight: 500;
    }

    .multiselect__content {
      padding: 8px 0 !important;
    }

    &.flex-options .multiselect__option {
      padding: 10px 10px !important;

      span {
        color: $blackPrimary;
      }
    }
  }
}
.sb2_reports_title {
  font-size: 22px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.87;
  letter-spacing: normal;
  text-align: left;
  color: #141c20;

  margin-top: 35px;
  margin-bottom: 0;
}

.sb2-chart-title {
    display: flex;

    span {
      color: $blackLight;
      font-size: 14px;
      font-weight: 500;
      text-transform: uppercase;
      margin-bottom: 9px;
      flex-grow: 2;

      &.ellipsis {
        margin-right: 12px;
      }

      &.report-btn {
        color: $bluePrimary;
        flex-grow: 0;
        flex-shrink: 0;

        &:hover {
          color: $blackPrimary;
          cursor: pointer;
        }
      }
    }
  }

.top-border {
  border-top: 1px solid $greyBorderSecondary;
  margin: 0 40px;
  max-width: 1441px !important;
}

::v-deep .multiselect {
  div.multiselect__content-wrapper {
    width: fit-content;
    min-width: 158px;
    margin-top: 9px;
  }
}

.member-loader {
  min-height: 279px;

  .member-loader-wrapper {
    width: 58px;
    height: 62px;
    border-radius: 15px;
    background-color: #f6f8f9;
    margin-bottom: 26px;
  }

  p {
    font-size: 14px;
    font-weight: 400;
    color: #9eafb5;
  }
}

.member-item {
  border-bottom-color: #edf0f2 !important;

  .member-name, .members-left {
    margin: 0 7px;
    font-size: 14px;
    font-weight: 500;
    color: $blackPrimary;
  }

  .members-left {
    color: $blackUltralight;
  }

  .member-value {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: $blackPrimary;
    cursor: default;
    padding: 18px 0;
  }

  &:hover {
    .members-left {
      color: $blackPrimary;
    }
  }
}

.y-padding-15 {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

div > .member-item:last-of-type {
  border: none !important;
}



@media (min-width: $medium) {
  .chart-wrapper {
    border: dashed $greyBorderSecondary;
    border-width: 0 1px 1px 0;
    padding: 29px 40px 0 40px;

    &:nth-child(2n+1) {
      &::before {
        content: '';
        display: block;
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 40px;
        height: 20px;
        background-color: white;
      }
    }

    &:nth-child(2n) {
      border-width: 0 0 1px 0;

      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -10px;
        right: 0;
        width: 40px;
        height: 20px;
        background-color: white;
      }
    }
  }
}

@media (min-width: $large) {
  .chart-wrapper {
    border: dashed $greyBorderSecondary;
    border-width: 0 1px 1px 0 !important;
    padding: 29px 40px 0 40px !important;

    &:nth-child(2n+1) {
      &::before {
        content: none;
      }
    }

    &:nth-child(2n) {
      border-width: 0 0 1px 0;

      &::after {
        content: '';
        display: none;
      }
    }

    &:nth-child(3n+1) {
      &::before {
        content: '';
        display: block;
        position: absolute;
        bottom: -10px;
        left: 0;
        width: 40px;
        height: 20px;
        background-color: white;
      }
    }

    &:nth-child(3n) {
      border-width: 0 0 1px 0 !important;

      &::after {
        content: '';
        display: block;
        position: absolute;
        bottom: -10px;
        right: 0;
        width: 40px;
        height: 20px;
        background-color: white;
      }
    }
  }
}
</style>
